import axios, { AxiosResponse } from 'axios';

import { Nafs } from 'src/Redux/Nafs/Types';

export async function getNafs() {
  return axios.get('nafs/').then((res: AxiosResponse<Nafs>) => res.data);
}
